export default t => ({
  longTermDefinitionDays: {
    "ui:widget": "number-input",
    "ui:options": {
      min: 0,
      label: t("LONG_TERM_DEFINITION_DAYS"),
      description: t("LONG_TERM_DAYS_DESCRIPTION"),
    },
  },
  longTermDefinitionType: {
    "ui:widget": "select",
    "ui:options": {
      label: t("LONG_TERM_DEFINITION_TYPE"),
      description: t("LONG_TERM_DAYS_TYPE_DESCRIPTION"),
    },
  },
  reportingPeriods: {
    "ui:widget": "hidden",
  },
  bradfordScore: {
    "ui:widget": "hidden",
  },
  bradfordScoreAbsenceType: {
    "ui:widget": "hidden",
  },
  bradfordScoreDayType: {
    "ui:widget": "hidden",
  },
  bv12Trend: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("BV_TREND"),
      description: t("BV12_TREND_DESCRIPTION"),
    },
  },
  salaryCostAbsenceTrend: {
    "ui:widget": "hidden",
  },
  employeeAbsenceRates: {
    "ui:widget": "hidden",
  },
  rtwIncludedAbsenceRates: {
    "ui:widget": "hidden",
  },
  targetAbsenceRate: {
    "ui:widget": "number-input",
    "ui:options": {
      min: 0,
      label: t("TARGET_ABSENCE_RATE"),
      description: t("TARGET_ABSENCE_DESCRIPTION"),
    },
  },
  historicalDataUnderReporting: {
    "ui:widget": "number-input",
    "ui:options": {
      label: t("HISTORIC_DATA_UNDER_REPORTING"),
      description: t("DATA_UNDER_REPORTING_DESCRIPTION"),
    },
  },
  estimatedDailyAbsenceCost: {
    "ui:widget": "number-input",
    "ui:options": {
      label: t("DAILY_ABSENCE_COST"),
      description: t("DAILY_ABSENCE_COST_DESCRIPTION"),
    },
  },
  bradfordScorePeriod: {
    "ui:widget": "hidden",
  },
  descriptionReasonSuspectedUnderReporting: {
    "ui:widget": "hidden",
  },
  descriptionReasonCostAbsence: {
    "ui:widget": "hidden",
  },
  absenceRateCalculationType: {
    "ui:widget": "hidden",
  },
  "ui:order": [
    "longTermDefinitionDays",
    "longTermDefinitionType",
    "bv12Trend",
    "targetAbsenceRate",
    "estimatedDailyAbsenceCost",
    "historicalDataUnderReporting",
    "*",
  ],
});
